import React from 'react';
import './SubHeader.scss';


const SubHeader = ({ text }) => {
  return (
    <div className="subHeading-wrapper">
      <h2 className="subHeading-text">{text}</h2>
    
    </div>
  );
};

export default SubHeader;
